module.exports = __webpack_public_path__ + "img/AnalysisScreenShot4.f9a3122c.png";